import { FC, PropsWithChildren } from "react";

import './Button.scss';

interface iProps {
    action? : () => void,
	className?: string,
	disabled?: boolean,

	onBlur?: (...args: any) => void,
	onFocus?: (...args: any) => void,
	// onBlur?: () => void,
	// onFocus?: () => void,
	onMouseOut?: (...args: any) => void,
	onMouseOver?: (...args: any) => void,
}


const Button: FC<PropsWithChildren<iProps>> = ({
	children,
	className,
	action,
	disabled,

	onBlur,
	onFocus,
	onMouseOut,
	onMouseOver,
}) => {

	return (
		<div
			onClick={() => (action && !disabled) && action()}
			className={
				'Button ' +
				(className || '') +
				(disabled? ' Button-disabled' : '')
			}
			onBlur={onBlur}
			onFocus={onFocus}
			onMouseOut={onMouseOut}
			onMouseOver={onMouseOver}
		>
			{children}
		</div>
	)
}

export default Button;